<template>
  <v-container>
    <iframe :src="url || 'https://blog.orionstereo.org/'"
    frameborder="0"
    class="blog"
    ></iframe>
  </v-container>
</template>

<script>
export default {
  props: ['url']
}
</script>

<style>
.blog {
  width: 100%;
  height: 560px;
}
</style>
